import { FC } from 'react';
import { BrowserRouter as Router, Redirect, Switch } from 'react-router-dom';
import AdminView from '../modules/Admin';
import Authentication from '../modules/Authentication';
import Config from '../modules/Config';
import Coupons from '../modules/Coupons';
import Dashboard from '../modules/Dashboard';
import DynamicPage from '../modules/DynamicPage';
import DynamicShowcase from '../modules/DynamicShowcase';
import MapIndex from '../modules/Map';
import MenuItems from '../modules/MenuItem';
import MenuItemsLocation from '../modules/MenuItemsLocation';
import Screen from '../modules/Screen';
import Users from '../modules/Users';
import CustomTag from '../modules/CustomTag';
import Route from './Route';

const Routes: FC = () => (
  <Router>
    <Route exact path="/" component={() => <Redirect to="/auth" />} />
    <Switch>
      <Route path="/auth" component={Authentication} />
      <Route
        exact
        path="/dashboard"
        component={Dashboard}
        isDashboard
        isPrivate
      />
      <Route path="/map/:id" component={MapIndex} isPrivate />
      <Route path="/screens" component={Screen} isDashboard isPrivate />
      <Route path="/users" component={Users} isDashboard isPrivate />
      <Route path="/customTag" component={CustomTag} isDashboard isPrivate />
      <Route path="/configs" component={Config} isDashboard isPrivate />
      <Route path="/menu-items" component={MenuItems} isDashboard isPrivate />
      <Route path="/coupons" component={Coupons} isDashboard isPrivate />

      <Route
        path="/menu-items-location"
        component={MenuItemsLocation}
        isDashboard
        isPrivate
      />

      <Route
        path="/dynamic_pages"
        component={DynamicPage}
        isDashboard
        isPrivate
      />
      <Route
        path="/dynamic_showcase"
        component={DynamicShowcase}
        isDashboard
        isPrivate
      />
      <Route
        path="/cmsadmin"
        component={AdminView}
        isDashboard
        onlySysAdmin
        isPrivate
      />
      <Route component={() => <h1>401</h1>} />
    </Switch>
  </Router>
);

export default Routes;
